import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface ODSPConfig {
    odspProvisioningCheckIntervals: string;
    odspProvisioningPendingImage: string;
    odspProvisioningStatusApiPath: string;
}

@Injectable({
    providedIn: 'root'
})
export class ODSPConfigService {
    public readonly config: ODSPConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<ODSPConfig>('odspConfig') || {
            odspProvisioningCheckIntervals: null,
            odspProvisioningPendingImage: null,
            odspProvisioningStatusApiPath: null
        };
    }
}
